// extracted by mini-css-extract-plugin
export default {"list":"QTWUDLTB","listItem":"kawnn48w","incoming":"YrKb0ova","link":"FhsU0zwq"};